import { Link } from 'react-router-dom';

// Reused by React Router's catch-all and the Aurora gate (invalid knock); the
// two must render identical output so they're indistinguishable from outside.
export function NotFound() {
  return (
    <section className="py-12">
      <p className="label mb-4">404</p>
      <h1 className="font-display text-3xl md:text-4xl font-medium mb-4">
        Page not found.
      </h1>
      <p className="text-ink-muted max-w-prose mb-6">
        Whatever you were looking for isn't here. It may have moved, or it
        may have never existed.
      </p>
      <Link to="/" className="label no-underline hover:text-accent">
        ← Home
      </Link>
    </section>
  );
}
